import { render, staticRenderFns } from "./SlotsForm.vue?vue&type=template&id=62ff88de&scoped=true"
import script from "./SlotsForm.vue?vue&type=script&lang=js"
export * from "./SlotsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ff88de",
  null
  
)

export default component.exports